// F-AGENT — plug the real Agent chat pane into the F-SHELL registry seam.
//
// Same seam proof as F-SOURCES / F-PLAN (plan §2.1): the feature self-registers
// via this `register.ts`, the barrel `features/index.ts` imports it as a
// side-effect, and the shell renders the Pane — with ZERO edit to any shared
// shell file. The acceptance gate is an EMPTY `git diff main -- src/ui/shell/`.
//
// `labelKey` REUSES the F-SHELL key `shell.tab.agent` (does not duplicate it);
// `order: 20` matches the FROZEN `KNOWN_TABS` slot (sources=10/agent=20/plan=30).
//
// `live` is a SELECTOR (read live by the shell each render): it lights the
// tab's gold pulse while a turn is streaming, without the feature pushing into
// shell state.

import { createElement } from 'react'
import { registerTab } from '@/ui/shell/tab-registry'
import { useAgentStore } from '@/ui/stores/use-agent-store'
import { AgentPane } from './AgentPane'

registerTab({
  id: 'agent',
  order: 20,
  labelKey: 'shell.tab.agent',
  // Neutral sparkle glyph for the AI/agent surface (RTL-agnostic — not a
  // direction-implying icon, so no scaleX flip needed per CLAUDE.md §9.2
  // rule 3).
  icon: createElement('span', { 'aria-hidden': true }, '✦'),
  Pane: AgentPane,
  // Gold live-pulse while a turn streams (read live; no shell-state push).
  live: () => useAgentStore.getState().isStreaming,
})
